import { Pipe, PipeTransform } from '@angular/core';
import moment, { Moment } from 'moment';

@Pipe({
  name: 'unixDateFormat',
  standalone: true
})
export class UnixDateFormatPipe implements PipeTransform {
  transform(value: number | string, dateFormat?: string): string | Moment {
    if (!value) return '';
    const formattedDate = moment.unix(Number(value)).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
    if (dateFormat) {
      return formattedDate?.format(dateFormat);
    }
    return formattedDate;
  }
}
